import { Component, OnInit } from '@angular/core';
import { UIBaseService } from '../../../services/uibase.service';
import { Footer } from '../../../models/footer.model';

@Component({
  selector: 'cop-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
  standalone: false
})
export class PublicFooterComponent implements OnInit {

  footer: Footer = new Footer([], "");

  constructor(private uibase: UIBaseService) { }

  ngOnInit() {
    this.footer = new Footer(
      this.uibase.pageFooter["footerlinks"],
      this.uibase.pageFooter["footernote"]
    );
  }

}
